import React from "react";
import { motion } from "framer-motion";
import {
  Box,
  CardHeader,
  Container,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import { servicesData } from "../../constants";
import { fadeIn, staggerContainer } from "../../utils/motion";
import { TitleText, TypingText } from "../../components/CustomTexts";

const Services = () => {
  const subHeader = (
    <TypingText
      title="| this is a list of our services"
      textStyles="text-center"
    />
  );
  const header = <TitleText title="our services" textStyles="text-center" />;
  return (
    <Container id="services">
      <motion.div
        variants={staggerContainer}
        initial="hidden"
        whileInView="show"
        viewport={{ once: false, amount: 0.25 }}
      >
        <CardHeader title={header} subheader={subHeader} />
        <Grid container spacing={2}>
          {servicesData.map((project, index) => (
            <Grid item xs={12} sm={6} key={index}>
              <motion.div
                variants={fadeIn("up", "spring", index * 0.5, 1)}
                className="flex md:flex-row flex-col gap-4"
              >
                <Paper
                  sx={{
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    height: "100%",
                    p: "0.5rem",
                  }}
                >
                  <Typography
                    variant="h4"
                    color="secondary"
                    sx={{ fontVariant: "all-small-caps" }}
                  >
                    {project.title}
                    <hr />
                  </Typography>
                  <Box sx={{ position: "relative" }}>
                    <Box
                      sx={{
                        position: "relative",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={project.illustration}
                        height="200"
                        width="500"
                        alt={project.name}
                        style={{
                          height: "30vh",
                          width: "100%",
                          opacity: "0.5",
                          "&:active, &:active:focus, &:hover": {
                            opacity: "1",
                          },
                        }}
                      />
                      <Typography
                        sx={{
                          textTransform: "uppercase",
                          position: "absolute",
                          backgroundColor: (theme) =>
                            theme.palette.background.navigation,
                          p: "0.5rem",
                          borderRadius: "10px",
                        }}
                      >
                        {project.service}
                      </Typography>
                    </Box>
                  </Box>
                  <Typography
                    variant="body2"
                    sx={{ fontVariant: "all-small-caps" }}
                  >
                    {project.technologies}
                  </Typography>
                </Paper>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </motion.div>
    </Container>
  );
};

export default Services;
